import projection from '../generated/pw250af1.json'; import { AcceptanceManifest } from '../types';
export const pw250af1AcceptanceManifest = projection as AcceptanceManifest;
